module.exports = __webpack_public_path__ + "static/img/6690_phase_function_Paper_PointsHejduk_Prediction.b55d2b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6690_phase_function_Paper_PointsHejduk_Prediction.png
// module id = HlO/
// module chunks = 0